import React from 'react'
import style from './styles/awards.module.scss'

const AwardsCard = ({
  name,
  date,
  image
}): React.ReactElement => {
  const slicedDate = date !== null ? date.slice(0, 10) : ''
  return (
    <figure className={style.awards}>
      <img
        src={image}
        width='712px'
        height='400px'
        alt='name'
        loading='lazy'
        className={style.awards__image}
      />
      <span className={style.awards__date}>{slicedDate}</span>
      <figcaption className={style.awards__title}>{name}</figcaption>
    </figure>
  )
}

export default AwardsCard
